import { Route } from '@angular/router';
import { STATUS_CHECK_ROUTE } from 'eurogard-status-check';

export const appRoutes: Route[] = [
  STATUS_CHECK_ROUTE,
  {
    path: 'error',
    loadChildren: () => import('angular-components/error/routes'),
  },
  {
    path: '',
    loadChildren: () => import('./layout.routes'),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
